<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 3.64447V12.3556H2.00005V3.64447H14ZM13.6 2.40002H2.40005C1.52005 2.40002 0.800049 2.96002 0.800049 3.64447V12.3556C0.800049 13.04 1.52005 13.6 2.40005 13.6H13.6C14.48 13.6 15.2 13.04 15.2 12.3556V3.64447C15.2 2.96002 14.48 2.40002 13.6 2.40002Z" fill="#FCFCFC"/>
  </svg>
</template>

<script>
export default {
  name: 'task-icon'
}
</script>

<style scoped>
path {
  stroke-width: 0 !important;
  fill: currentColor;
}
</style>
